// extracted by mini-css-extract-plugin
export default {"color-grey-5":"#DADADA","colorGrey5":"#DADADA","color-subtle-grey":"#f5f4f2","colorSubtleGrey":"#f5f4f2","overlay":"_3Uztj","divider":"_2Fyls","disclaimer":"_1Q0Xq"};